import { Link } from 'react-router-dom';
import './Landing.css';

const Landing = () => {
    return (
        <div className="landing-page">
            {/* Hero Section */}
            <section className="hero-section">
                <div className="hero-container">
                    <div className="hero-content">
                        <div className="hero-logo">
                            <svg width="48" height="48" viewBox="0 0 100 100" fill="none">
                                <defs>
                                    {/* Background gradient */}
                                    <linearGradient id="bgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#22d3ee" />
                                        <stop offset="50%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#8b5cf6" />
                                    </linearGradient>
                                    {/* Checkmark gradient */}
                                    <linearGradient id="checkGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#06b6d4" />
                                        <stop offset="50%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#a855f7" />
                                    </linearGradient>
                                </defs>

                                {/* Main container with rounded corners */}
                                <rect x="10" y="15" width="80" height="72" rx="12" ry="12" fill="url(#bgGradient)" />

                                {/* Grid cells - top row (filled) */}
                                <rect x="15" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />
                                <rect x="40" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />
                                <rect x="65" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />

                                {/* Grid cells - middle rows (white) */}
                                <rect x="15" y="34" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="34" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="34" width="20" height="10" rx="2" fill="white" />

                                <rect x="15" y="48" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="48" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="48" width="20" height="10" rx="2" fill="white" />

                                {/* Grid cells - bottom row (white) */}
                                <rect x="15" y="62" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="62" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="62" width="20" height="10" rx="2" fill="white" />

                                {/* Large checkmark */}
                                <path d="M50 53 L65 68 L95 30"
                                    stroke="url(#checkGradient)"
                                    strokeWidth="8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    fill="none" />
                            </svg>
                            <span className="hero-logo-text">Spreadsheetr</span>
                        </div>

                        <h1 className="hero-title">
                            Stop Worrying About
                            <span className="hero-title-highlight"> Excel Breaking Your Business</span>
                        </h1>

                        <p className="hero-description">
                            Transform critical spreadsheets into bulletproof systems. Perfect for schools, SMBs, NGOs, and any organization tired of the "Excel person" dependency.
                        </p>

                        <div className="hero-actions">
                            <Link to="/register" className="btn btn-primary btn-lg hero-cta">
                                Get Started
                            </Link>
                            <Link to="/login" className="btn btn-secondary btn-lg hero-login">
                                Sign In
                            </Link>
                        </div>

                        <div className="hero-trust">
                            <p className="hero-trust-text">Trusted by schools, businesses, and nonprofits worldwide</p>
                        </div>
                    </div>

                    <div className="hero-visual">
                        <div className="hero-card">
                            <div className="hero-card-header">
                                <div className="hero-card-dots">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                                <span className="hero-card-title">School Fee Calculator.xlsx</span>
                            </div>
                            <div className="hero-card-content">
                                <div className="hero-before">
                                    <div className="excel-problems">
                                        <div className="problem-item">
                                            <span className="problem-icon">⚠️</span>
                                            <span className="problem-text">Sarah built this in 2019</span>
                                        </div>
                                        <div className="problem-item">
                                            <span className="problem-icon">❌</span>
                                            <span className="problem-text">File corrupted twice</span>
                                        </div>
                                        <div className="problem-item">
                                            <span className="problem-icon">😰</span>
                                            <span className="problem-text">Sarah left last month</span>
                                        </div>
                                        <div className="problem-item">
                                            <span className="problem-icon">🔒</span>
                                            <span className="problem-text">Nobody dares touch it</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="hero-arrow">
                                    <div className="arrow-content">
                                        <span className="arrow-symbol">→</span>
                                        <span className="arrow-text">Spreadsheetr</span>
                                    </div>
                                </div>
                                <div className="hero-after">
                                    <div className="solution-panel">
                                        <div className="solution-header">
                                            <span className="solution-status">✅ Active Template</span>
                                        </div>
                                        <div className="solution-content">
                                            <div className="solution-item">
                                                <span className="solution-label">Fee Structure:</span>
                                                <span className="solution-value">Bulletproof</span>
                                            </div>
                                            <div className="solution-item">
                                                <span className="solution-label">Team Access:</span>
                                                <span className="solution-value">5 users</span>
                                            </div>
                                            <div className="solution-item">
                                                <span className="solution-label">Calculations:</span>
                                                <span className="solution-value">2,847 runs</span>
                                            </div>
                                            <div className="solution-item">
                                                <span className="solution-label">Errors:</span>
                                                <span className="solution-value">Zero</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Features Section */}
            <section className="features-section">
                <div className="features-container">
                    <div className="features-header">
                        <h2>Why Organizations Choose Spreadsheetr</h2>
                        <p>Eliminate Excel dependency and calculation errors across your operations</p>
                    </div>

                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                    <circle cx="9" cy="7" r="4" />
                                    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                            </div>
                            <h3>End "Excel Person" Dependency</h3>
                            <p>No more panic when the person who built your critical spreadsheets leaves. Institutionalize knowledge and ensure business continuity.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                                    <path d="M9 12l2 2 4-4" />
                                </svg>
                            </div>
                            <h3>Bulletproof Calculations</h3>
                            <p>Perfect for payroll, fees, inventory, and budgets where errors are costly. Every calculation is logged and auditable for compliance.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M12 2L2 7l10 5 10-5-10-5z" />
                                    <path d="M2 17l10 5 10-5" />
                                    <path d="M2 12l10 5 10-5" />
                                </svg>
                            </div>
                            <h3>Built for Real Organizations</h3>
                            <p>Schools managing fees and payroll. SMBs tracking inventory and commissions. NGOs ensuring grant compliance. Manufacturing calculating BOMs.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                                </svg>
                            </div>
                            <h3>Lightning Fast & Reliable</h3>
                            <p>Execute complex calculations in milliseconds. No more waiting for Excel to process large datasets or worrying about file corruption.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                                    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                                    <line x1="12" y1="22.08" x2="12" y2="12" />
                                </svg>
                            </div>
                            <h3>API Integration Ready</h3>
                            <p>Integrate calculations into your existing systems. Perfect for automating routine processes and connecting with other business tools.</p>
                        </div>

                        <div className="feature-card">
                            <div className="feature-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="3" />
                                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1 1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                                </svg>
                            </div>
                            <h3>Multi-User & Role-Based</h3>
                            <p>Multiple team members can access calculations with proper permissions. Admins control access, operators run calculations, everyone stays productive.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Target Sectors Section */}
            <section className="sectors-section">
                <div className="sectors-container">
                    <div className="sectors-header">
                        <h2>Built for Organizations Like Yours</h2>
                        <p>Spreadsheetr serves the backbone calculations that keep these sectors running</p>
                    </div>

                    <div className="sectors-grid">
                        <div className="sector-card">
                            <div className="sector-icon">🏫</div>
                            <h3>Education</h3>
                            <p>Schools, colleges, and institutions</p>
                            <ul>
                                <li>Student fees and billing</li>
                                <li>Staff payroll calculations</li>
                                <li>Inventory and supplies</li>
                                <li>Term-to-term reporting</li>
                            </ul>
                        </div>

                        <div className="sector-card">
                            <div className="sector-icon">🏢</div>
                            <h3>Small & Medium Business</h3>
                            <p>Operations and finance teams</p>
                            <ul>
                                <li>Pricing rules and commissions</li>
                                <li>Payroll and benefits</li>
                                <li>Stock summaries</li>
                                <li>Financial reconciliations</li>
                            </ul>
                        </div>

                        <div className="sector-card">
                            <div className="sector-icon">🤝</div>
                            <h3>NGOs & Non-Profits</h3>
                            <p>Program and finance officers</p>
                            <ul>
                                <li>Budget tracking</li>
                                <li>Fund allocation logic</li>
                                <li>Grant compliance reporting</li>
                                <li>Donor transparency</li>
                            </ul>
                        </div>

                        <div className="sector-card">
                            <div className="sector-icon">🏭</div>
                            <h3>Manufacturing</h3>
                            <p>Production and inventory teams</p>
                            <ul>
                                <li>BOM calculations</li>
                                <li>Batch summaries</li>
                                <li>Yield tracking</li>
                                <li>Consumables control</li>
                            </ul>
                        </div>

                        <div className="sector-card">
                            <div className="sector-icon">🚛</div>
                            <h3>Logistics & Transport</h3>
                            <p>Fleet and operations managers</p>
                            <ul>
                                <li>Cost calculations</li>
                                <li>Route summaries</li>
                                <li>Driver allowances</li>
                                <li>Usage reports</li>
                            </ul>
                        </div>

                        <div className="sector-card">
                            <div className="sector-icon">🏥</div>
                            <h3>Healthcare Admin</h3>
                            <p>Hospital and clinic administrators</p>
                            <ul>
                                <li>Inventory tracking</li>
                                <li>Billing logic (non-PII)</li>
                                <li>Operational reporting</li>
                                <li>Resource allocation</li>
                            </ul>
                        </div>
                    </div>

                    <div className="sectors-cta">
                        <p><strong>The Common Thread:</strong> Organizations that need <em>one correct way</em> to run critical calculations, without depending on the "Excel person."</p>
                    </div>
                </div>
            </section>

            {/* How It Works Section */}
            <section className="how-it-works-section">
                <div className="how-it-works-container">
                    <div className="how-it-works-header">
                        <h2>From Excel Chaos to System Reliability</h2>
                        <p>Transform your critical spreadsheets in three simple steps</p>
                    </div>

                    <div className="steps-grid">
                        <div className="step-card">
                            <div className="step-number">1</div>
                            <div className="step-content">
                                <h3>Upload Your Critical Spreadsheet</h3>
                                <p>Upload that payroll calculator, fee structure, or inventory tracker that everyone's afraid to touch. Our system analyzes the logic automatically.</p>
                            </div>
                        </div>

                        <div className="step-card">
                            <div className="step-number">2</div>
                            <div className="step-content">
                                <h3>Review & Activate</h3>
                                <p>Verify the extracted calculations match your expectations. Set user permissions and activate when ready. Your knowledge is now institutionalized.</p>
                            </div>
                        </div>

                        <div className="step-card">
                            <div className="step-number">3</div>
                            <div className="step-content">
                                <h3>Run Calculations Reliably</h3>
                                <p>Team members execute calculations through our portal or API. No more Excel crashes, version conflicts, or "who has the latest file?" confusion.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="cta-container">
                    <div className="cta-content">
                        <h2>Ready to Eliminate Excel Dependency?</h2>
                        <p>Join schools, businesses, and nonprofits who've made their critical calculations bulletproof</p>
                        <div className="cta-actions">
                            <Link to="/register" className="btn btn-primary btn-lg">
                                Start Free Trial
                            </Link>
                            <Link to="/login" className="btn btn-secondary btn-lg">
                                Sign In
                            </Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Footer */}
            <footer className="landing-footer">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-logo">
                            <svg width="24" height="24" viewBox="0 0 100 100" fill="none">
                                <defs>
                                    {/* Background gradient */}
                                    <linearGradient id="footerBgGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#22d3ee" />
                                        <stop offset="50%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#8b5cf6" />
                                    </linearGradient>
                                    {/* Checkmark gradient */}
                                    <linearGradient id="footerCheckGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#06b6d4" />
                                        <stop offset="50%" stopColor="#3b82f6" />
                                        <stop offset="100%" stopColor="#a855f7" />
                                    </linearGradient>
                                </defs>

                                {/* Main container with rounded corners */}
                                <rect x="10" y="15" width="80" height="72" rx="12" ry="12" fill="url(#footerBgGradient)" />

                                {/* Grid cells - top row (filled) */}
                                <rect x="15" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />
                                <rect x="40" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />
                                <rect x="65" y="20" width="20" height="10" rx="2" fill="rgba(255,255,255,0.3)" />

                                {/* Grid cells - middle rows (white) */}
                                <rect x="15" y="34" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="34" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="34" width="20" height="10" rx="2" fill="white" />

                                <rect x="15" y="48" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="48" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="48" width="20" height="10" rx="2" fill="white" />

                                {/* Grid cells - bottom row (white) */}
                                <rect x="15" y="62" width="20" height="10" rx="2" fill="white" />
                                <rect x="40" y="62" width="20" height="10" rx="2" fill="white" />
                                <rect x="65" y="62" width="20" height="10" rx="2" fill="white" />

                                {/* Large checkmark */}
                                <path d="M50 53 L65 68 L95 30"
                                    stroke="url(#footerCheckGradient)"
                                    strokeWidth="8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    fill="none" />
                            </svg>
                            <span>Spreadsheetr</span>
                        </div>
                        <p className="footer-tagline">
                            Stop worrying about Excel breaking your business
                        </p>
                    </div>
                    <div className="footer-links">
                        <Link to="/privacy">Privacy Policy</Link>
                        <Link to="/login">Sign In</Link>
                        <Link to="/register">Get Started</Link>
                    </div>
                </div>
                <div className="footer-bottom">
                    <p>&copy; 2026 Spreadsheetr. All rights reserved.</p>
                </div>
            </footer>
        </div>
    );
};

export default Landing;